import { render, staticRenderFns } from "./EventsDataTable.vue?vue&type=template&id=22c043ef"
import script from "./EventsDataTable.vue?vue&type=script&lang=js"
export * from "./EventsDataTable.vue?vue&type=script&lang=js"
import style0 from "./EventsDataTable.vue?vue&type=style&index=0&id=22c043ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports